import React from 'react';
import { FaChevronRight } from 'react-icons/fa';
import '../../../../asset/new/css/employer-modern.css';

const EmployerLayout = ({ breadcrumbs, children }) => {
  return (
    <div className="employer-main-content">
      {/* Breadcrumbs */}
      {breadcrumbs && breadcrumbs.length > 0 && (
        <div className="employer-breadcrumb">
          {breadcrumbs.map((crumb, index) => (
            <React.Fragment key={index}>
              {index > 0 && (
                <FaChevronRight className="employer-breadcrumb-separator" size={12} />
              )}
              <span
                className={
                  index === breadcrumbs.length - 1
                    ? 'employer-breadcrumb-current'
                    : 'employer-breadcrumb-item'
                }
              >
                {crumb}
              </span>
            </React.Fragment>
          ))}
        </div>
      )}
      
      {/* Main Content */}
      <div className="employer-container">
        {children}
      </div>
    </div>
  );
};

export default EmployerLayout;
